import React, { Component } from "react";
import { style } from "typestyle";
import IconPlus from "../icons/Plus";
import IconMinus from "../icons/Minus";

interface Props {
  map: L.Map;
}

export default class MapZoomControl extends Component<Props> {
  UNSAFE_componentWillMount() {
    this.props.map.on("zoomend", this.handleMapZoomChange);
  }

  componentWillUnmount() {
    this.props.map.off("zoomstart", this.handleMapZoomChange);
  }

  handleMapZoomChange = () => {
    this.forceUpdate();
  };

  handleZoomInClick = () => {
    this.props.map.zoomIn();
  };

  handleZoomOutClick = () => {
    this.props.map.zoomOut();
  };

  render() {
    const { map } = this.props;
    const currentZoom = map.getZoom();
    const minZoom = map.getMinZoom();
    const maxZoom = map.getMaxZoom();

    return (
      <div
        className={style({
          cursor: "pointer",
          background: "white",
          borderRadius: "2px",
          boxShadow:
            "0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)",
        })}
      >
        <div className={zoomButtonCN} onClick={this.handleZoomInClick}>
          <IconPlus color={currentZoom >= maxZoom ? "#9e9e9e" : "#000"} />
        </div>
        <div className={zoomButtonCN} onClick={this.handleZoomOutClick}>
          <IconMinus color={currentZoom <= minZoom ? "#9e9e9e" : "#000"} />
        </div>
      </div>
    );
  }
}

const zoomButtonCN = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "40px",
  height: "40px",
  userSelect: "none",
  borderBottom: "1px solid #E6E6E6",
  $nest: {
    "&:last-child": {
      borderBottom: "none",
    },
  },
});
